/**
 * Curriculum List Component
 * Displays list of user's curriculums with selection
 */

import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { BookOpen, Loader2 } from 'lucide-react';

const CurriculumList = ({ 
    curriculums, 
    loading, 
    selectedId, 
    onSelect, 
    onCreateNew,
    getStatusColor 
}) => {
    if (loading) {
        return (
            <div className="flex items-center justify-center py-8">
                <Loader2 className="h-6 w-6 animate-spin" />
            </div>
        );
    }

    if (curriculums.length === 0) {
        return (
            <Card className="text-center py-8">
                <CardContent>
                    <BookOpen className="h-12 w-12 mx-auto mb-3 text-muted-foreground opacity-50" />
                    <p className="text-muted-foreground">No curriculums yet</p>
                    <Button 
                        variant="outline" 
                        className="mt-4"
                        onClick={onCreateNew}
                    >
                        Create Your First Curriculum
                    </Button>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="space-y-3">
            {curriculums.map(curr => (
                <Card 
                    key={curr.id}
                    className={`cursor-pointer transition-all hover:shadow-md ${
                        selectedId === curr.id ? 'ring-2 ring-primary' : ''
                    }`}
                    onClick={() => onSelect(curr)}
                    data-testid={`curriculum-item-${curr.id}`}
                >
                    <CardContent className="p-4">
                        <div className="flex items-start justify-between">
                            <div className="flex-1 min-w-0">
                                <h3 className="font-medium truncate">{curr.title}</h3>
                                <p className="text-xs text-muted-foreground mt-1">
                                    {curr.modules?.length || 0} modules
                                </p>
                            </div>
                            <Badge className={getStatusColor(curr.status)}>
                                {curr.status}
                            </Badge>
                        </div>
                        {curr.generation_status === 'generating' && (
                            <div className="mt-3">
                                <Progress value={curr.generation_progress || 0} className="h-1" />
                                <p className="text-xs text-muted-foreground mt-1">
                                    {curr.generation_message || 'Generating...'}
                                </p>
                            </div>
                        )}
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default CurriculumList;
